<template lang="pug">
.list
  .title Вставить блок
  .inner-list
    .block(
      v-for='(block, index) in blocks',
      :key='index',
      @click='$emit("click", block)'
    )
      .icon
        v-icon {{ block.icon }}
      .caption {{ block.title }}
</template>

<script>
export default {
  data: () => ({
    blocks: require('@/enums/blocks').blocks.list,
  }),
}
</script>

<style scoped lang="scss">
.title {
  top: 0;
  left: 0;
  position: sticky;
  padding: 24px;
  text-align: center;
  background: rgba(255, 255, 255, 1);
}
.list {
  width: 220px;
  background: white;
  max-height: 500px;
  overflow: auto;
  padding-bottom: 0;
  position: sticky;
  top: 90px;
  user-select: none;
}
.inner-list {
  padding: 0 24px 0 24px;
}
.block {
  height: 60px;
  padding: 12px;
  display: flex;
  cursor: pointer;
  line-height: 100%;
  text-align: center;
  margin: 0 0 12px 0;
  background: rgba(0, 0, 0, 0.03);
  align-items: center;
  flex-direction: column;
  justify-content: center;
  &:hover {
    background: rgba(0, 0, 0, 0.06);
  }
}
.list::-webkit-scrollbar {
  background: transparent;
  overflow: visible;
  width: 3px;
}
.list::-webkit-scrollbar-thumb:horizontal {
  min-width: 3px;
}
.list::-webkit-scrollbar-thumb:vertical {
  min-height: 3px;
}
.list::-webkit-scrollbar-corner {
  background: transparent;
}
.list::-webkit-scrollbar-thumb {
  background-color: #adadad;
}
</style>
